import { render, staticRenderFns } from "./CrossSectional.vue?vue&type=template&id=368c8e6f&scoped=true"
import script from "./CrossSectional.vue?vue&type=script&lang=js"
export * from "./CrossSectional.vue?vue&type=script&lang=js"
import style0 from "./CrossSectional.vue?vue&type=style&index=0&id=368c8e6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c8e6f",
  null
  
)

export default component.exports